
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'perso-1': {
    width: 55.8,
    height: 115,
    viewBox: '0 0 55.8 115',
    data: '<path pid="0" d="M3 53.2l9.9-11.9 9.6-9.3h19l5-12.6V3M12.3 110.5l4.3-5.5.8-21L33 59.9l8.9 20.2 4.7 24.5 6.2 7.4" _fill="none" _stroke="#fc0f3a" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/><path pid="1" d="M31.8 13.8L29.5 26v12.5L34 61.4" _fill="none" _stroke="#fc0f3a" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/>'
  }
})
